import TeamMemberInvitationAcceptView from './TeamMemberInvitationAcceptView';

export default TeamMemberInvitationAcceptView;
